import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { StudentDataModel, StudentResponseModel } from './student.model';

export const onGetStudents = (page: number, limit: number): Promise<StudentDataModel> => {
  return axiosInstance.get(http_config.BASE_URL + '/student?page=' + page + '&limit=' + limit);
};
export const onSetStudents = (payload: StudentResponseModel): Promise<StudentResponseModel> => {
  return axiosInstance.post(http_config.BASE_URL + '/student', payload);
};

export const onDeleteStudent = (payload: StudentResponseModel): Promise<StudentResponseModel> => {
  return axiosInstance.delete(http_config.BASE_URL + '/student/{id}', { data: payload.id });
};

export const onGetStudentByGrade = (
  grade: String,
  sectionId: string,
): Promise<StudentResponseModel[]> => {
  return axiosInstance.get(
    http_config.BASE_URL + '/student/grade/' + grade + '/section/' + sectionId,
  );
};
